module.exports = __webpack_public_path__ + "img/kiosk-map-wayfinder-directory.cec2e2ad.png";